import React from "react";
import '../about/About.css';
import image2 from '../../image/my-sora2.jpeg'
import { AiOutlineFundProjectionScreen } from "react-icons/ai";
import { SlBadge } from "react-icons/sl";




function About(){
    return(
        <>
        <h2 className="page">About Me</h2>
        <div className="about text-[#4db5ff] flex justify-around items-center mt-10" >
            <div className="image2 m-5 rounded-3xl bg-[#4db5ff]">
                <img src={image2} alt="" className="rounded-3xl"/>
            </div>
            <div className="text m-5">
                <div className="ex flex justify-between items-center">
                   <div className="experience bg-gradient-to-r from-[#3b82f652] flex flex-col  items-center rounded-md mb-3"> 
                    <SlBadge className=" text-xl" />
                    <h1 className=" text-2xl m-2">Experience</h1>
                    <p className=" text-white text-l">1+ Years Working</p>
                   </div>
                   <div className="projects bg-gradient-to-r from-[#3b82f652] flex flex-col  items-center rounded-md mb-3">
                    <AiOutlineFundProjectionScreen className=" text-xl"/>
                    <h1 className=" text-2xl m-2">Projects</h1>
                    <p className=" text-white text-l">5+ Completed</p>
                   </div>
                </div>
                <div className="summery bg-gradient-to-r from-[#3b82f652] p-5 rounded-md mt-3 text-xl">
                    <p>My greatest strength is making a beautiful and amazing websites. I have made a lot of projects on my profile. I will be so glad if you become one of my connections. We can learn a lot of things from each other and sharing our experience together. 😊</p>
                </div>
            </div>
        </div>
        </>
    )
}

export default About;